export default {
  mounted () {
    const adsbygoogle = document.createElement('script');
    const adpusher = document.createElement('script');

    adsbygoogle.src = '//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
    adpusher.innerHTML = '(adsbygoogle = window.adsbygoogle || []).push({});';

    document.body.appendChild(adsbygoogle);
    document.body.appendChild(adpusher);
  }
};



// WEBPACK FOOTER //
// ./src/components/ads-container/ads-container.js